import React, { useMemo, useState } from "react";
import { SelectTagWidgetContainer } from "../../BroadcastView.styles";
import {
  BroadcastAppCard,
  ContainerActions,
  FormContainer,
  FormInputContainer,
  FormInputLabel,
  FormInputDescription,
  NotificationPanel,
  NotificationTitle,
  NotificationIcon,
  NotificationText,
  NotificationContainer,
  SectionHeaderIcon,
} from "../styles";
import { BackLink } from "../../Campaigns.style";
import Button from "../../../../../components/shared/components/button/Button.style";
import { useBroadcastTags } from "../hooks/use-broadcast-tags";

export const TagContactsForm = ({
  handleNext,
  handleBack,
  updateBroadcastData,
  broadcastData,
}) => {
  const { tags, isLoading } = useBroadcastTags();
  const [selectedTagId, setSelectedTagId] = useState(
    broadcastData?.tagId || null,
  );
  const [query, setQuery] = useState("");

  const filteredTags = useMemo(() => {
    if (!query.trim()) return tags;
    const normalizedQuery = query.toLowerCase();
    return tags.filter((tag) =>
      tag.name?.toLowerCase().includes(normalizedQuery),
    );
  }, [tags, query]);

  const handleSelectTag = (tag) => {
    setSelectedTagId((prev) => (prev === tag.id ? null : tag.id));
  };

  const persistSelection = () => {
    const selectedTag = tags.find((tag) => tag.id === selectedTagId) || null;
    updateBroadcastData({
      tagId: selectedTag?.id || null,
      tagName: selectedTag?.name || null,
    });
  };

  const handleContinue = () => {
    persistSelection();
    handleNext();
  };

  const handleOnBack = () => {
    persistSelection();
    handleBack();
  };

  return (
    <SelectTagWidgetContainer>
      <BroadcastAppCard>
        <NotificationContainer>
          <FormContainer onSubmit={(event) => event.preventDefault()}>
            <FormInputContainer>
              <FormInputLabel>
                <SectionHeaderIcon>🏷️</SectionHeaderIcon>
                Etiquetar contactos
              </FormInputLabel>

              <FormInputDescription>
                Selecciona una etiqueta para asignarla a los contactos que
                reciban este mensaje. Es opcional: puedes continuar sin elegir
                ninguna.
              </FormInputDescription>

              <input
                type="text"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Buscar etiqueta..."
                style={{
                  width: "100%",
                  padding: "0.625rem 0.75rem",
                  marginTop: "0.75rem",
                  borderRadius: "8px",
                  border: "1px solid #d1d5db",
                  fontSize: "0.875rem",
                  fontFamily: '"Inter", sans-serif',
                  outline: "none",
                }}
              />

              <div
                style={{
                  marginTop: "0.75rem",
                  maxHeight: "320px",
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                }}
              >
                {isLoading ? (
                  <div
                    style={{
                      padding: "1.5rem",
                      textAlign: "center",
                      color: "#9ca3af",
                      fontSize: "0.875rem",
                    }}
                  >
                    Cargando etiquetas...
                  </div>
                ) : filteredTags.length === 0 ? (
                  <div
                    style={{
                      padding: "1.5rem",
                      textAlign: "center",
                      color: "#9ca3af",
                      fontSize: "0.875rem",
                    }}
                  >
                    {tags.length === 0
                      ? "No hay etiquetas registradas en la empresa"
                      : "Sin resultados"}
                  </div>
                ) : (
                  filteredTags.map((tag) => {
                    const isSelected = tag.id === selectedTagId;
                    return (
                      <button
                        key={tag.id}
                        type="button"
                        onClick={() => handleSelectTag(tag)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.625rem",
                          padding: "0.625rem 0.75rem",
                          borderRadius: "8px",
                          border: isSelected
                            ? "1px solid #128c7e"
                            : "1px solid #e5e7eb",
                          backgroundColor: isSelected ? "#f0f9f7" : "#ffffff",
                          cursor: "pointer",
                          textAlign: "left",
                          transition: "all 0.15s ease",
                        }}
                        aria-pressed={isSelected}
                      >
                        <span
                          style={{
                            width: "14px",
                            height: "14px",
                            borderRadius: "50%",
                            backgroundColor: tag.color || "#9ca3af",
                            flexShrink: 0,
                          }}
                        />
                        <span
                          style={{
                            flex: 1,
                            fontSize: "0.875rem",
                            color: "#374151",
                            fontWeight: isSelected ? 600 : 400,
                          }}
                        >
                          {tag.name}
                        </span>
                        <span
                          style={{ fontSize: "0.75rem", color: "#9ca3af" }}
                        >
                          {tag.clientCount ?? 0} contactos
                        </span>
                      </button>
                    );
                  })
                )}
              </div>
            </FormInputContainer>
          </FormContainer>

          <NotificationPanel>
            <NotificationTitle>
              <NotificationIcon />
              ¿Cómo funciona?
            </NotificationTitle>

            <NotificationText>
              Cuando la campaña se envíe, la etiqueta seleccionada se asignará
              automáticamente a cada contacto que reciba el mensaje. Esto te
              permite:
            </NotificationText>

            <ul
              style={{
                margin: "1rem 0 0 0",
                paddingLeft: "1.5rem",
                fontSize: "0.875rem",
                color: "#0c4a6e",
                lineHeight: "1.8",
              }}
            >
              <li>Segmentar a quienes recibieron una campaña específica</li>
              <li>Crear audiencias para futuros envíos</li>
              <li>Dar seguimiento por equipo o estado del contacto</li>
            </ul>

            <NotificationText style={{ marginTop: "1rem" }}>
              <strong>Nota:</strong> El etiquetado es opcional. Puedes continuar
              sin seleccionar ninguna etiqueta.
            </NotificationText>
          </NotificationPanel>
        </NotificationContainer>

        <ContainerActions>
          <BackLink onClick={handleOnBack}>← Atrás</BackLink>

          <Button designV4 onClick={handleContinue}>
            {selectedTagId ? "Continuar" : "Omitir y continuar"}
          </Button>
        </ContainerActions>
      </BroadcastAppCard>
    </SelectTagWidgetContainer>
  );
};
